import LoyaltyRedeemCashSFC from "./LoyaltyRedeemCash.vue";
export const LoyaltyRedeemCash = LoyaltyRedeemCashSFC;
